import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";

import axios from "axios";
import { getDeviceId } from "./utils/deviceId";

const deviceId = getDeviceId();

axios.interceptors.request.use(
  function (config) {
    config.headers["X-Device-Id"] = deviceId;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

loadFonts();

createApp(App).use(router).use(store).use(vuetify).mount("#app");
